import React, { useEffect, useRef, useState } from 'react'
import './copy-game.styles.scss';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { ModalAlert, ModalConfirm } from '@/components/modal/modal.component';
import { UseCloudFunction } from '@/utils/firebase.utils';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import FullPageLoader from '@/components/loader/full-page-loader.component';
import BackButton from '@/components/SHARED/back-button/back-button.component';

const CopyGame = ({
    managingList,
}) => {

    const userProfile = useSelector(state => state.userData.userProfile);
    const screenSize = useSelector(state => state.contentData.screenSize);
    const [ loading, setLoading] = useState(true);
    const [ fullLoading, setFullLoading ] = useState(false);
    const [ alertMessage, setAlertMessage ] = useState(null);
    const [ confirmMessage, setConfirmMessage ] = useState(null);
    const timeoutRef = useRef();
    const approveRef = useRef();
    const navigate = useNavigate();

    useEffect(() => {
        timeoutRef.current = setTimeout(() => {
            setLoading(false);
        }, 2000)

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        }
    }, [])

    function createGameCopy(gameId) {
        setConfirmMessage(`Are you sure you want to copy this game?`);
        approveRef.current = () => {
            continueCopy();
        }

        async function continueCopy() {
            setFullLoading(true);
            const res = await UseCloudFunction(
                'duplicateOwnerGame',
                {
                    'gameId': gameId,
                    'appId': userProfile.appId,
                    'userProfile': userProfile,
                }
            )
            console.log(res);
            setFullLoading(false);
            if (res.error) {
                setAlertMessage(`Something went wrong. 
                    Please try again later. (Error: ${res.error})`
                );
                return;
            } 
            setAlertMessage(`Game copied successfully!`);
            approveRef.current = () => {
                navigate(`/manage/${res.gameData.path}`);
            }
        }

    }

    return (
        <div className={`copy-game ${screenSize}`}>
            <div className='g-card'>
            <BackButton cancel={() => navigate(-1)} />
                <div className='g-space-1'></div>
                <div className='card-title'>
                    Copy an Existing Game
                </div>
                <hr  />
                <div className='copy-game-content'>
                    <p>Choose a game below to create a copy.</p>
                    {
                        (loading)
                        ?
                        <div className='center-col'>
                            <ThreeDotsLoader />
                        </div>
                        :
                        (managingList && Object.values(managingList).length > 0) 
                        ? 
                        <div className='game-list'>
                        {
                            Object.values(managingList).map((game, index) => {
                                return (
                                    <div 
                                        className={`game-item g-list-item ${screenSize}`} 
                                        key={index}>
                                        <div className='game-item-head'>
                                            <div className='game-icon'>
                                                <ImageContainer 
                                                    src={game.icon} 
                                                    alt='game icon' />
                                            </div>
                                            <div className='game-name'>
                                                {game.gameName}
                                            </div>
                                        </div>
                                        <div className='meta'>
                                            Elements: {game.createdElementTotal ?? 0}
                                        </div>
                                        <div className='meta'>
                                            Teams: {game.createdTeams ?? 0}
                                        </div>
                                        <div className='buttons'>
                                            <button 
                                                id="copy-button"
                                                className='g-button small-btn'
                                                onClick={() => createGameCopy(game.gameId)}>
                                                Copy
                                            </button>
                                        </div>
                                    </div>
                                )
                            })
                        }
                        </div>
                        :
                        <div className='center-col'>
                            No games available to copy.
                        </div>
                    }
                </div>
            </div>
            {
                (screenSize === 'mobile') &&
                <div className="g-space-1"></div>
            }
            <ModalAlert
                show={alertMessage}
                cancel={() => setAlertMessage(null)}
                message={alertMessage}
                onApprove={approveRef.current} />
            <ModalConfirm
                show={confirmMessage}
                cancel={() => setConfirmMessage(null)}
                message={confirmMessage}
                onApprove={approveRef.current} />
            <FullPageLoader show={fullLoading} />
        </div>
    )
}

export default CopyGame